import React from "react";
import { Link } from 'react-router-dom';

import queryString from 'qs'

// core components
import Wizard from "components/Wizard/Wizard.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Footer from "components/Footer/Footer.jsx";
import PreLoginHeader from "components/Header/PreLoginHeader.jsx";

import UserInfo from "./SignupSteps/UserInfo.jsx";
import Dentist from "./SignupSteps/Dentist.jsx";
import Address from "./SignupSteps/Address.jsx";
import Payment from "./SignupSteps/Payment.jsx";
import Agreement from "./SignupSteps/Agreement.jsx";
import SubmitAgreement from "./SignupSteps/SubmitAgreement.jsx";
import Plan from "./SignupSteps/Plan.jsx";


import SweetAlert from "react-bootstrap-sweetalert";


import sweetAlertStyle from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.jsx";

import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";
import { getSearchString } from "../../assets/helpers/urlHelper";
import { COMPANY_WEB_SITE, API_ROOT } from "../../api-config";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import axios from "axios";

const style = {
  ...loginPageStyle,
  ...sweetAlertStyle
};

class SignupView extends React.Component {
  constructor(props) {
    super(props);
    const searchString = getSearchString(this.props.location.search)
    const paramValues = queryString.parse(searchString)
    var provider = ''
    var invitationCode = ''
    if (paramValues.provider) {
      provider = paramValues.provider
      if (paramValues.invitationCode) {
        invitationCode = paramValues.invitationCode
      }
    }
    this.state = {
      provider: provider,
      invitationCode: invitationCode,
      alert: ''
    };
  }
  componentDidMount() {
    //check for and confirm an invitation code - matters only if the provider requires an invitation
    if (this.state.provider) {
      axios.get(`${API_ROOT}/invitationCode/?providerUuid=` + this.state.provider + `&invitationCode=` + this.state.invitationCode, { headers: getApiHeaders() })
        .then(res => this.handleInvitationCodeCheck({ responseMessage: res.data }));
    }
  }

  handleInvitationCodeCheck(res) {
    const validCode = res.responseMessage.validCode
    if (!validCode) {
      const titleText = 'invitation issue'
      this.setState({
        alert: (
          <div id="invalidInvitationCodeAlert">
            <SweetAlert
              style={{ display: "block", marginTop: "-100px" }}
              title={titleText}
              onConfirm={() => window.location.replace(COMPANY_WEB_SITE)}
              confirmBtnCssClass={
                this.props.classes.button + " " + this.props.classes.success
              }
              confirmBtnText="Visit mycirrusdental.com"
            >
              The invitation you are using has either already been used or is invalid. Please request a new invitation from your dentist.
            </SweetAlert>
          </div>
        )
      })
    }
  }



  render() {
    const { classes } = this.props;
    let steps;
    if (this.state.provider) {
      steps = [
          { stepName: "welcome", stepComponent: Dentist, stepId: "provider" },
          { stepName: "subscription", stepComponent: Plan, stepId: "plan" },
          { stepName: "account info", stepComponent: UserInfo, stepId: "userInfo" },
          { stepName: "address", stepComponent: Address, stepId: "address" },
          { stepName: "review terms", stepComponent: Agreement, stepId: "agreement" },
          { stepName: "payment", stepComponent: Payment, stepId: "payment" },
          { stepName: "submit", stepComponent: SubmitAgreement, stepId: "submitAgreement" }
        ]
    } else {
      steps = [
        { stepName: "account info", stepComponent: UserInfo, stepId: "userInfo" },
        { stepName: "address", stepComponent: Address, stepId: "address" },
        { stepName: "dentist", stepComponent: Dentist, stepId: "provider" },
        { stepName: "subscription", stepComponent: Plan, stepId: "plan" },
        { stepName: "review terms", stepComponent: Agreement, stepId: "agreement" },
        { stepName: "payment", stepComponent: Payment, stepId: "payment" },
        { stepName: "submit", stepComponent: SubmitAgreement, stepId: "submitAgreement" }
      ]
    }
    return (
      <div>
        {this.state.alert}
        <PreLoginHeader />
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={12} md={12}>
            <div style={{textAlign: 'center'}}>
              Already have an account? <Link className={classes.linkClass} to="/login">Log in here.</Link>
            </div>
          </GridItem>
        </GridContainer>
        <GridContainer justifyContent="center">
          <GridItem xs={12} sm={8}>
            <Wizard
              validate
              steps={steps}
              title="Set up your account"
              subtitle="This information will get you set up and ready for care."
            />
          </GridItem>
        </GridContainer>
        <Footer fluid />
      </div>
    );
  }
}

export default withStyles(style)(SignupView);
